// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_18QmIk8tJFe2KhhQ_F9Bgr"};